import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

const pages = import.meta.glob('../pages/*.vue')

function route(path, file, name, extra) {

    const component = pages[`../pages/${file}.vue`]

    return {
        exact: true,
        ...extra,
        path,
        name,
        component
    }
}

Vue.use(Router)

const router = new Router({
    base: import.meta.env.BASE_URL,
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        route('/login', 'Login', 'login'),
        route('/error', 'Error', 'error', { props: (route) => ({ message: route.query.message }) }),
        route('/notfound', 'NotFound', 'notfound'),

        route('/', 'Main', null, {
            children: [
                route('/practices', 'Practices', 'practices', { alias: '/' }),
                route('/practices/new', 'NewPractice', 'newPractice'),
                route('/users', 'Users', 'users'),
            ]
        }),

        // Global redirect for 404
        { path: '*', redirect: '/notfound' }
    ]
})

router.beforeEach((to, from, next) => {

    const publicPages = ['/login', '/error']
    const authRequired = !publicPages.includes(to.path)
    const loggedIn = store.getters.isAuthenticated

    if (authRequired && !loggedIn) {
        return next('/login')
    }

    next()
})

//router.beforeEach((to, from, next) => {
//  global.store.dispatch('checkPageTitle', to.path)
//  next()
//})

export default router
